module.exports = __webpack_public_path__ + "img/232.6d86a1dd.jpg";